/**
 * The MecaRadar logo, from the brand kit (`mecaradar-logo-kit/`, served from `public/`).
 *
 * Two images, one per theme: the main logo on light backgrounds, the "blanc" one on dark — the
 * kit asks for them not to be recoloured, so the theme swaps files rather than filtering one. The
 * swap is CSS (`.dark .mds .logo …` in mds.css), so every caller must render this inside an
 * element carrying `.mds`.
 *
 * `wordmark={false}` shows the square icon alone, for places with no room for the lettering.
 */
export function MdsLogo({ wordmark = true }: { wordmark?: boolean }) {
  if (!wordmark) {
    return (
      <span className="logo">
        <img className="logo-icon" src="/mecaradar-icone.svg" alt="MecaRadar" />
      </span>
    );
  }
  return (
    <span className="logo">
      <img className="logo-light" src="/mecaradar-logo.svg" alt="MecaRadar" />
      <img className="logo-dark" src="/mecaradar-logo-blanc.svg" alt="" aria-hidden="true" />
    </span>
  );
}
